import type { CanDeactivateFn } from '@angular/router'

export type UnsavedPlaceEditor = {
  hasUnsavedChanges(): boolean
}

export const placeUnsavedChangesGuard: CanDeactivateFn<UnsavedPlaceEditor> = (
  component
) =>
  !component.hasUnsavedChanges() ||
  window.confirm('Odrzucić niezapisane zmiany miejsca?')
